// rdp.ts — open an RDP session against a NetBird-reachable host.
//
// Browsers no longer honour `rdp://` links reliably (Chrome and Edge silently
// swallow unknown protocol handlers unless the user has gone through the
// External Protocol Handler prompt, which usually never fires for first-time
// callers). The robust path that has worked on every Windows + macOS combo
// we've tested is to download a tiny `.rdp` file — the OS hands it to mstsc /
// Microsoft Remote Desktop the moment the user opens it from the downloads
// shelf. The settings below are the minimum that produces a working session
// when the user double-clicks the file.

const FILE_BODY = (ip: string): string => [
    'screen mode id:i:2',           // 2 = full screen, 1 = windowed
    'use multimon:i:0',
    `full address:s:${ip}:3389`,
    'audiomode:i:0',                // play on local
    'redirectclipboard:i:1',
    'authentication level:i:0',     // do not require server auth
    'prompt for credentials:i:1',
    'negotiate security layer:i:1',
    '',
].join('\r\n');

function sanitiseFilename(s: string): string {
    // Keep the filename printable and free of path separators. Anything
    // outside [A-Za-z0-9._-] gets squashed to a single dash so the OS doesn't
    // refuse the download.
    return s.replace(/[^A-Za-z0-9._-]+/g, '-').replace(/^-+|-+$/g, '') || 'site';
}

export function openRdp(ip: string, label?: string): void {
    if (!ip) return;
    const body = FILE_BODY(ip);
    const blob = new Blob([body], { type: 'application/x-rdp' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${sanitiseFilename(label || ip)}.rdp`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    setTimeout(() => URL.revokeObjectURL(url), 1000);
}
